import React, { useEffect, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { injectIntl, IntlShape } from 'react-intl';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  TableBody,
  Tabs,
  Tab,
} from '@material-ui/core';
import { get, isEmpty, uniqueId } from 'lodash';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {
  Container,
  Dialog,
} from 'containers/CourtManagerAssignedClaims/styled-components';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { translate } from 'containers/services/translate';
import { ROW_PER_PAGE } from 'constants/global';
import { AssignedClaim } from 'containers/CourtManagerAssignedClaims/typings';
import messages from 'containers/CourtManagerAssignedClaims/messages';
import {
  formatLossdate,
  formatUpdateDate,
  getAssignedManagerCode,
} from 'containers/CourtManagerAssignedClaims/utils';
import { makeSelecClaimRecap } from 'containers/RecapManagerPage/selectors';
import { resetSearchClaimsStore } from 'containers/IdentificationPage/actions';
import { shouldDisplayAssignmentDialogButtonCourtManager } from 'containers/ManagerOpenedClaimsPage/utils';
import {
  requestAssignedClaimsBySubServices,
  requestAssignClaimToManager,
} from 'containers/CourtManagerAssignedClaims/actions';
import { resetStoreClaim } from 'containers/RecapManagerPage/actions';
import { setStepV2 } from 'containers/CourtManagerAssignedClaims/utils';
import { setStep } from 'containers/LawyerAssignmentsPage/utils';
import {
  makeSelectAssignedClaims,
  makeSelectAssignedClaimsCount,
} from 'containers/CourtManagerAssignedClaims/selectors';
import { StyledSahamTabs } from 'containers/LawyerAssignmentsPage/styled-components';
import { createStructuredSelector } from 'reselect';
import routesHelper from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import * as utils from 'containers/RecapManagerPage/utils';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import {
  requestAssigment,
  requestCorporealLawyers,
} from 'containers/RecapManagerPage/actions';
import { resetStoreSearch } from 'containers/ManagerHomePage/actions';
import { CLAIM_STATUS, LISTINGS } from 'containers/data-structure';
import { hasFeature } from 'features/fflip-helpers';
import { SEARCH_TYPE } from 'containers/ValidatedClaimsPage/constants';
import { requestSearch } from 'containers/ValidatedClaimsPage/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getTabLabelsV2 } from 'containers/common/LegalProceedings/utils';
import AssignmentDialog from 'containers/RecapManagerPage/AssignmentDialog';
import { displayStatus } from 'containers/LawyerAssignmentsPage/utils';
import {
  makeSelectCorporealLawyers,
  makeSelecOpenedClaim,
} from 'containers/RecapManagerPage/selectors';
import NewSearchBar, { SearchQuery } from 'components/NewSearchBar';
import { SEARCH_QUERY_INIT_VALUES } from 'components/NewSearchBar/constants';
import { isManager } from 'containers/AppContainer/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { formatAssignedClaims } from 'containers/ManagerHomePage/utils';

export interface CourtManagerAssignedClaimsProps {
  intl: IntlShape;
  assignedClaims: AssignedClaim[];
  assignedClaimsCount: number;
  requestAssignedClaimsBySubServices: Function;
  requestAssignClaimToManager: Function;
  listings: Listings;
  requestSearch: Function;
  requestAssigment: Function;
  requestCorporealLawyers: Function;
  corporealLawyers: any;
  openedClaim: any;
  claimRecap: {};
  location: { pathname: string };
  resetStoreSearch: Function;
  resetSearchClaimsStore: Function;
  resetStoreClaim: Function;
}

export const CourtManagerAssignedClaims: React.FC<CourtManagerAssignedClaimsProps> = (
  props,
): JSX.Element => {
  const DEFAULT_PAGE_SIZE = 50; // TO DO : to delete when tabs are fixed, bug (SINC-1571)
  const [page, setPage] = useState(0);
  const [row, setRow] = useState(0);
  const [pageSize, setRowsPerPage] = useState(DEFAULT_PAGE_SIZE);
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState<
    boolean
  >(false);
  const [currentAssignment, setCurrentAssignment] = useState({
    claimId: 0,
    assignmentId: 0,
  });
  const [tab, setTab] = React.useState(0);
  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>(
    SEARCH_QUERY_INIT_VALUES,
  );
  const labels = getTabLabelsV2(messages, props);
  const [activeLabel, setActiveLabel] = useState(get(labels, `${0}`));
  useDeepCompareEffect(() => {
    props.resetStoreSearch();
    props.resetSearchClaimsStore();
    props.resetStoreClaim();
  }, [props.claimRecap]);
  useEffect(() => {
    let procedureType = tab > 3 ? 'APPEAL' : 'FIRST_INSTANCE';
    !isEmpty(props.listings) &&
    featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER)
      ? props.requestAssignedClaimsBySubServices(
          page,
          pageSize,
          setStepV2(activeLabel)?.step,
          setStepV2(activeLabel)?.procedureType,
          getAssignedManagerCode(
            get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
            get(currentUserStorage.get(), 'username', ''),
          ),
          userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
          featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER),
        )
      : props.requestAssignedClaimsBySubServices(
          page,
          pageSize,
          setStep(tab),
          procedureType,
          getAssignedManagerCode(
            get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
            get(currentUserStorage.get(), 'username', ''),
          ),
          userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
          featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER),
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, page, props.listings, activeLabel]);

  const tableHeaders = [
    messages.claimNature,
    messages.claimNumber,
    messages.policyNumber,
    messages.registrationNumber,
    messages.lossDate,
    messages.assignedCourtManager,
    messages.assignedLawyer,
    messages.status,
    messages.updateDate,
  ];
  const handleChange = (event: React.ChangeEvent<{}>, newTabIndex: number) => {
    setTab(newTabIndex);
    setPage(0);
    setActiveLabel(get(labels, `${newTabIndex}`));
  };
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  /* istanbul ignore next */
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const size = parseInt(event.target.value, 10);
    setRowsPerPage(size);
  };

  /* istanbul ignore next */
  const handleCloseConfirmationDialog = () => {
    setIsConfirmationDialogOpen(false);
  };
  /* istanbul ignore next */
  const handleOpenCourtManagerAssignmentPopin = (index: number) => (event: {
    stopPropagation: Function;
  }) => {
    setRow(index);
    setAssignToACourtManagerDialogOpen(true);
    event.stopPropagation();
  };
  /* istanbul ignore next */
  const closeAndRefresh = () => {
    let procedureType = tab > 3 ? 'APPEAL' : 'FIRST_INSTANCE';
    setAssignToACourtManagerDialogOpen(false);
    featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER)
      ? props.requestAssignedClaimsBySubServices(
          page,
          pageSize,
          setStepV2(activeLabel)?.step,
          setStepV2(activeLabel)?.procedureType,
          getAssignedManagerCode(
            get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
            get(currentUserStorage.get(), 'username', ''),
          ),
          userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
          featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER),
        )
      : props.requestAssignedClaimsBySubServices(
          page,
          pageSize,
          setStep(tab),
          procedureType,
          getAssignedManagerCode(
            get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
            get(currentUserStorage.get(), 'username', ''),
          ),
          userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
          featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER),
        );
  };
  /* istanbul ignore next */
  const handleValidateConfirmationDialog = () => {
    const token = accessTokenStorage.get().token;
    props.requestAssignClaimToManager(
      {
        assignmentId: currentAssignment.assignmentId,
        token,
      },
      pushToPageByFflip,
    );
  };

  const pushToPageByFflip = (claimId: number = currentAssignment.claimId) => {
    let pageDestination = `${PAGES.MANAGER_RECAP_PAGE}/${claimId}`;

    if (hasFeature(FEATURES.MANAGER_JUDGEMENT_ADD)) {
      pageDestination = `${PAGES.COURT_MANAGER_LEGAL_PROCEEDINGS}/${claimId}`;
    }
    return routesHelper.pushTo(pageDestination)();
  };

  const handleAssignCourtManagerConfirmationDialog = (
    assignment: AssignedClaim,
  ) => () => {
    const { id, claim } = assignment;
    const claimId = claim?.id as number;

    setCurrentAssignment({
      claimId,
      assignmentId: id as number,
    });

    pushToPageByFflip(claimId);
  };

  const lawyers = utils.getListBySagisKey(
    get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
    get(props.listings, LISTINGS.STACKHOLDERS, []),
    ITEM_KEYS.LAWYER,
    SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
  ) as SagisConfig[];
  /* istanbul ignore next */
  const handlerSearch = () => {
    const query = {
      searchCriteria: {
        ...searchQuery,
        status: CLAIM_STATUS.VALIDATED,
        field: !userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER)
          ? {
              assignedManagerCode: getAssignedManagerCode(
                get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
                get(currentUserStorage.get(), 'username', ''),
              ),
            }
          : {},
      },
      searchType: SEARCH_TYPE.ASSIGNMENT,
    };
    props.requestSearch(query);
  };
  /* istanbul ignore next */
  const handlerRefresh = () => {
    let procedureType = tab > 3 ? 'APPEAL' : 'FIRST_INSTANCE';
    setSearchQuery({
      lossDate: null,
      registrationNumber: '',
      policyNumber: '',
      claimNumber: '',
      assuredCIN: '',
      assuredName: '',
      victimName: '',
      courtNumber: '',
      procedureNatureId: null,
      jurisdictionDegreeId: null,
      jurisdiction: null,
    });
    featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER)
      ? props.requestAssignedClaimsBySubServices(
          page,
          pageSize,
          setStepV2(activeLabel)?.step,
          setStepV2(activeLabel)?.procedureType,
          getAssignedManagerCode(
            get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
            get(currentUserStorage.get(), 'username', ''),
          ),
          userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
          featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER),
        )
      : props.requestAssignedClaimsBySubServices(
          page,
          pageSize,
          setStep(tab),
          procedureType,
          getAssignedManagerCode(
            get(props.listings, LISTINGS.ASSIGNMENT_MANAGER, []),
            get(currentUserStorage.get(), 'username', ''),
          ),
          userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER),
          featureService.hasFeature(FEATURES.ATTRIBUTION_INBOXES_MANAGER),
        );
  };

  const [
    isAssignToACourtManagerDialogOpen,
    setAssignToACourtManagerDialogOpen,
  ] = React.useState<boolean>(false);
  return (
    <Container>
      <Card>
        <CardContent>
          <div className="header">
            <Typography className="titleContainer">
              <div className="recap">
                <span className="recapValue">{props.assignedClaimsCount}</span>
              </div>
              <span className="title">
                {translate({ ...messages.tableTile }, props)}
              </span>
            </Typography>
            {hasFeature(FEATURES.SEARCH_BAR) && (
              <NewSearchBar
                isManager={isManager(props)}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                handlerSearch={handlerSearch}
                handlerRefresh={handlerRefresh}
                isHomePage={false}
                showAll={isManager(props)}
              />
            )}
          </div>
          {featureService.hasFeature(FEATURES.LEGAL_PROCEEDING_STEP) ? (
            <StyledSahamTabs>
              <Tabs
                value={tab}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChange}
                className="tab-container"
              >
                {labels.map((step: string) => (
                  <Tab label={step} data-testid="tab-2" />
                ))}
              </Tabs>
              <Table>
                <TableHead>
                  <TableRow className="row">
                    {tableHeaders.map(header => (
                      <TableCell
                        key={uniqueId('header')}
                        align="left"
                        className="headerTitle"
                      >
                        {translate(header, props)}
                      </TableCell>
                    ))}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                {!isEmpty(props.assignedClaims) &&
                  formatAssignedClaims(props.assignedClaims, false).map(
                    (assignment, index) => (
                      <TableBody key={get(assignment, 'id')}>
                        <TableRow
                          className="row"
                          onClick={() =>
                            pushToPageByFflip(
                              get(assignment, 'claim.id') as number,
                            )
                          }
                        >
                          <TableCell className="rowTable" align="left">
                            {get(assignment, 'claim')
                              ? translate(messages.claimNatureCorporeal, props)
                              : get(assignment, 'existingClaim.claimNature')}
                          </TableCell>
                          <TableCell align="left" className="rowTable">
                            {get(assignment, 'claim.claimNumber') ||
                              get(assignment, 'existingClaim.claimNumber')}
                          </TableCell>
                          <TableCell align="left" className="rowTable">
                            {get(assignment, 'claim.policyNumber') ||
                              get(assignment, 'existingClaim.policyNumber')}
                          </TableCell>
                          <TableCell align="left" className="rowTable">
                            {get(assignment, 'claim.registrationNumber') ||
                              get(
                                assignment,
                                'existingClaim.registrationNumber',
                              )}
                          </TableCell>

                          <TableCell align="left" className="rowTable">
                            {formatLossdate(
                              get(assignment, 'claim.lossDate'),
                              get(assignment, 'claim.lossHour'),
                            ) ||
                              formatLossdate(
                                get(assignment, 'existingClaim.lossDate'),
                                get(assignment, 'existingClaim.lossHour'),
                              )}
                          </TableCell>
                          <TableCell align="left" className="rowTable">
                            {get(assignment, 'assignedCourtManager')}
                          </TableCell>
                          <TableCell align="left" className="rowTable">
                            {!isEmpty(get(assignment, 'assignedLawyers'))
                              ? get(
                                  assignment,
                                  'assignedLawyers',
                                  [],
                                ).map((el: any) =>
                                  utils.getLawyerById(lawyers, el as string)
                                    ? `${utils.getLawyerById(
                                        lawyers,
                                        el as string,
                                      )}, `
                                    : '',
                                )
                              : utils.getLawyerById(
                                  lawyers,
                                  assignment.assignedLawyer as string,
                                )}
                          </TableCell>
                          <TableCell align="left" className="rowTable">
                            {translate(
                              get(
                                messages,
                                displayStatus(assignment as AssignedClaim),
                              ),
                              props,
                            )}
                          </TableCell>
                          <TableCell align="left" className="rowTable">
                            {formatUpdateDate(get(assignment, 'updatedAt'))}
                          </TableCell>
                          <TableCell
                            align="left"
                            className="rowTable"
                            onClick={handleOpenCourtManagerAssignmentPopin(
                              index,
                            )}
                          >
                            {shouldDisplayAssignmentDialogButtonCourtManager(
                              assignment as any,
                            ) ? (
                              <IconButton aria-label="delete">
                                <AddCircleOutlineIcon />
                              </IconButton>
                            ) : (
                              <></>
                            )}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ),
                  )}
              </Table>
              <TablePagination
                rowsPerPageOptions={ROW_PER_PAGE}
                component="div"
                count={props.assignedClaimsCount}
                rowsPerPage={pageSize}
                page={page}
                labelRowsPerPage={translate(
                  { ...messages.linesPerPage },
                  props,
                )}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </StyledSahamTabs>
          ) : (
            <div>
              <Table>
                <TableHead>
                  <TableRow className="row">
                    {tableHeaders.map(header => (
                      <TableCell
                        key={uniqueId('header')}
                        align="left"
                        className="headerTitle"
                      >
                        {translate(header, props)}
                      </TableCell>
                    ))}
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                {!isEmpty(props.assignedClaims) &&
                  props.assignedClaims.map(assignment => (
                    <TableBody key={assignment.id}>
                      <TableRow
                        className="row"
                        onClick={handleAssignCourtManagerConfirmationDialog(
                          assignment,
                        )}
                      >
                        <TableCell align="left">
                          {assignment.claim
                            ? translate(messages.claimNatureCorporeal, props)
                            : get(assignment.existingClaim, 'claimNature')}
                        </TableCell>
                        <TableCell align="left">
                          {get(assignment.claim, 'claimNumber') ||
                            get(assignment.existingClaim, 'claimNumber')}
                        </TableCell>
                        <TableCell align="left">
                          {get(assignment.claim, 'policyNumber') ||
                            get(assignment.existingClaim, 'policyNumber')}
                        </TableCell>
                        <TableCell align="left">
                          {get(assignment.claim, 'registrationNumber') ||
                            get(assignment.existingClaim, 'registrationNumber')}
                        </TableCell>

                        <TableCell align="left">
                          {formatLossdate(
                            get(assignment.claim, 'lossDate'),
                            get(assignment.claim, 'lossHour'),
                          ) ||
                            formatLossdate(
                              get(assignment.existingClaim, 'lossDate'),
                              get(assignment.existingClaim, 'lossHour'),
                            )}
                        </TableCell>
                        <TableCell align="left">
                          {assignment.assignedCourtManager}
                        </TableCell>
                        <TableCell align="left">
                          {utils.getLawyerById(
                            lawyers,
                            assignment.assignedLawyer as string,
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {assignment.claim && !isEmpty(assignment.claim) && (
                            <SecondaryButton
                              title={translate({ ...messages.summary }, props)}
                              onClick={() =>
                                pushToPageByFflip(
                                  get(assignment.claim, 'id') as number,
                                )
                              }
                            />
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ))}
              </Table>
              <TablePagination
                rowsPerPageOptions={ROW_PER_PAGE}
                component="div"
                count={props.assignedClaimsCount}
                rowsPerPage={pageSize}
                page={page}
                labelRowsPerPage={translate(
                  { ...messages.linesPerPage },
                  props,
                )}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </div>
          )}
        </CardContent>
      </Card>
      {isConfirmationDialogOpen && (
        <Dialog
          open={isConfirmationDialogOpen}
          handleClose={handleCloseConfirmationDialog}
          handleValidate={handleValidateConfirmationDialog}
          title={translate(messages.assignToCourtManagerTitle, props)}
          confirmTitle={translate(messages.assignConfirmTitle, props)}
          cancelTitle={translate(messages.assignCancelTitle, props)}
        >
          <div className="content">
            {translate(messages.assignToCourtManagerDialogContent, props)}
          </div>
          <div className="info-message">
            {translate(messages.assignToCourtManagerInfoMessage, props)}
          </div>
        </Dialog>
      )}
      <AssignmentDialog
        open={isAssignToACourtManagerDialogOpen}
        onClose={setAssignToACourtManagerDialogOpen}
        subServices={get(props.listings, LISTINGS.SUB_SERVICES, [])}
        zonesCodes={get(props.listings, LISTINGS.ZONE_CODES, [])}
        services={get(props.listings, LISTINGS.SERVICES, [])}
        stackholders={get(props.listings, LISTINGS.STACKHOLDERS, [])}
        stackholderTypes={get(props.listings, LISTINGS.STACKHOLDER_TYPE, [])}
        requestAssigment={props.requestAssigment}
        claim={formatAssignedClaims(props.assignedClaims, false)[row] as any}
        closeAndRefresh={closeAndRefresh}
        requestCorporealLawyers={props.requestCorporealLawyers}
        corporealLawyers={props.corporealLawyers}
        shouldAssignOnSagis={false}
        isManagerOpenedClaimsPage
        isManager
        listings={props.listings}
        claimNumber={get(props.openedClaim, 'data.claimNumber')}
      />
    </Container>
  );
};

const mapDispatchToProps = {
  requestAssignedClaimsBySubServices,
  requestAssignClaimToManager,
  requestSearch,
  requestAssigment,
  requestCorporealLawyers,
  resetStoreClaim,
  resetSearchClaimsStore,
  resetStoreSearch,
};
const mapStateToProps = createStructuredSelector({
  assignedClaims: makeSelectAssignedClaims(),
  assignedClaimsCount: makeSelectAssignedClaimsCount(),
  corporealLawyers: makeSelectCorporealLawyers(),
  listings: makeSelectListings(),
  openedClaim: makeSelecOpenedClaim(),
  claimRecap: makeSelecClaimRecap(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CourtManagerAssignedClaims));
